import React from 'react';
import { Link } from 'react-router-dom';

const ToolCard = ({ icon, title, description, stats, gradientClass, customContent, iconColor, path }) => {
  // Define the card content structure once
  const cardInnerContent = (
    // Add flex flex-col flex-1 here to make the inner content container fill the height and layout vertically
    <div className="relative flex flex-col flex-1"> 
      <div className="flex items-center mb-4">
        <div className={`w-12 h-12 rounded-xl bg-opacity-30 flex items-center justify-center mr-4 ${iconColor} 
        transform-gpu group-hover:scale-110 group-hover:rotate-3 transition-medium flex-shrink-0`}> {/* Added flex-shrink-0 */}
          <i className={`fas ${icon} text-xl`}></i>
        </div>
        <h3 className="text-lg font-bold group-hover:text-white transition-medium">{title}</h3>
      </div>
      {/* Allow description to take its natural height */}
      <p className="text-gray-400 text-sm mb-4 group-hover:text-gray-300 transition-medium">{description}</p> 
      
      {/* Push stats/custom content to the bottom */}
      <div className="mt-auto"> 
        {stats && stats.length > 0 ? (
          <div className="flex justify-between items-center text-xs text-gray-500">
            {stats.map((stat, index) => (
              <span key={index} className="group-hover:scale-105 transition-medium">
                {stat.label}: <span className={`${stat.colorClass} group-hover:opacity-100 opacity-90 transition-medium`}>{stat.value}</span>
              </span>
            ))}
          </div>
        ) : null}
        {customContent && <div className="transition-medium group-hover:opacity-100 opacity-90">{customContent}</div>}
      </div>

      {/* Corner flourish (keep as is) */}
      <div className="absolute -bottom-4 -right-4 w-16 h-16 opacity-10 bg-white rounded-full blur-xl group-hover:opacity-20 transition-medium"></div>
    </div>
  );

  // Apply h-full and flex flex-col to the outer container (Link or div)
  const cardContainerClasses = `
    bg-dark-600 ${gradientClass} rounded-2xl p-5 hover:shadow-lg transition-medium 
    gradient-border transform-gpu hover:-translate-y-1 hover:shadow-glow active:translate-y-0 
    active:shadow-inner cursor-pointer group overflow-hidden relative 
    h-full flex flex-col 
  `; // Added h-full flex flex-col

  return path ? (
    <Link to={path} className={cardContainerClasses}>
      {/* Background glow effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-accent-pink/10 to-accent-purple/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-medium pointer-events-none"></div>
      {cardInnerContent}
    </Link>
  ) : (
    <div className={cardContainerClasses}>
      {/* Background glow effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-accent-pink/10 to-accent-purple/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-medium pointer-events-none"></div>
      {cardInnerContent}
    </div>
  );
};

export default ToolCard;